import React, { useState, useEffect } from 'react';
import { styled } from "@mui/material/styles";
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { applyPredefinedFormat, updateModalManager } from '../../../reducers/configurator/configuratorSlice';
import { resetLayers } from '../../../reducers/configurator/utils';
import { presetFormats } from '../constants';

const PREFIX = 'ConfigPredefinedFormatsForm'

const classes = {
  root: `${PREFIX}-root`,
  actionsButtons: `${PREFIX}-actionsButtons`,
  presetDisclaimer: `${PREFIX}-presetDisclaimer`,
  selectStyle: `${PREFIX}-selectStyle`,
  marginBottom: `${PREFIX}-marginBottom`,
  formControlStyle: `${PREFIX}-formControlStyle`,
  generatingLoaderContainer: `${PREFIX}-generatingLoaderContainer`,
  generatingLoader: `${PREFIX}-generatingLoader`

}

const ConfigPredefinedFormatsFormContainer = styled('div')((
  {
    theme
  }
) => {
  return {
    [`& .${classes.root}`]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      marginTop: '0.5rem',
    },
    [`& .${classes.actionsButtons}`]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end',
      width: '100%',
    },
    [`& .${classes.presetDisclaimer}`]: {
      textAlign: 'center',
      fontWeight: 'bold',
      marginBottom: '2rem',
    },
    [`& .${classes.selectStyle}`]: {
      width: '100%',
      marginBottom: '2rem',
    },
    [`& .${classes.marginBottom}`]: {
      marginBottom: '2rem',
    },
    [`& .${classes.formControlStyle}`]: {
      width: '25%',
      [theme.breakpoints.down('sm')]: {
        width: '40%',
      },
      margin: '0 auto',
    },
    [`& .${classes.generatingLoaderContainer}`]: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
    },
    [`& .${classes.generatingLoader}`]: {
      margin: '1rem auto'
    },
  }
})

const ConfigPredefinedFormatsForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isPreseting, setIsPreseting] = useState(false);
  const [statePreset, setStatePreset] = useState({
    selected: "",
    options: null,
  })

  useEffect(() => {
    const tmpPresets = [];
    Object.keys(presetFormats).forEach(key => tmpPresets.push({ value: key, label: key, key }));
    setStatePreset({ ...statePreset, options: tmpPresets });
  }, [])

  const handleCloseModal = () => {
    dispatch(updateModalManager(resetLayers.modalManager));
  }

  return (
    <ConfigPredefinedFormatsFormContainer sx={{ width: '100%' }}>
      <div className={classes.root}>
        {isPreseting ?
          <div className={classes.generatingLoaderContainer}>
            <CircularProgress size={50} className={classes.generatingLoader} />
            <Typography variant="body1">
              {t('configurator.generatingMessage')}
            </Typography>
          </div>
          :
          <>
            <Typography variant="body1" className={classes.marginBottom}>
              {t('configurator.presetDescription')}
            </Typography>
            <FormControl variant="outlined" className={classes.formControlStyle}>
              <InputLabel id="preset-formats-selector">{t("configurator.formatSelectPlaceholder")}</InputLabel>
              <Select
                labelId="preset-formats-selector"
                id="preset-format-selector"
                label={t("configurator.formatSelectPlaceholder")}
                className={classes.selectStyle}
                value={statePreset.selected || ""}
                onChange={e => setStatePreset({ ...statePreset, selected: e.target.value })}
              >
                {statePreset?.options?.map(item => (
                  <MenuItem aria-label={item.value === '' ? "None" : item.label} value={item.value} key={item.key}>
                    {item.label === '' ? 'None' : item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {statePreset.selected &&
              <Typography variant="body1" className={classes.presetDisclaimer}>
                {t('configurator.presetDisclaimer')}
              </Typography>
            }
            <div className={classes.actionsButtons}>
              <Button onClick={() => handleCloseModal()} color="primary">
                {t('configurator.reject')}
              </Button>
              <Button
                color="primary"
                disabled={statePreset.selected === ''}
                style={{
                  backgroundColor: statePreset.selected === '' && 'inherit',
                }}
                onClick={() => {
                  setIsPreseting(true);
                  dispatch(applyPredefinedFormat(statePreset.selected));
                  handleCloseModal();
                }}
              >
                {t('configurator.confirm')}
              </Button>
            </div>
          </>
        }
      </div>
    </ConfigPredefinedFormatsFormContainer>
  )
}

export default ConfigPredefinedFormatsForm;